'use client';

import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Soon = () => {
  return (
    <div className="min-h-screen bg-white text-black font-sans">
      <Navbar />

      <section className="relative min-h-[80vh] flex items-center justify-center px-6 overflow-hidden">
        {/* Subtle grid background */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#e5e7eb_1px,transparent_1px),linear-gradient(to_bottom,#e5e7eb_1px,transparent_1px)] bg-[size:80px_80px] opacity-40" />

        {/* Soft gradient wash */}
        <div className="absolute inset-0 bg-gradient-to-br from-white via-white to-gray-100 opacity-80" />

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="relative z-10 max-w-2xl text-center"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-gray-400 mb-6">
            Under Construction
          </p>

          <h1 className="text-4xl md:text-6xl font-light tracking-wide mb-6">
            This space is taking shape
          </h1>

          <p className="text-gray-600 leading-relaxed mb-10">
            We are currently developing this part of the studio — refining its structure,
            narrative, and material presence. Please return soon to explore it in full.
          </p>

          <div className="flex items-center justify-center space-x-6">
            <a
              href="/"
              className="text-sm tracking-wide text-black border-b border-black pb-1 hover:opacity-60 transition"
            >
              Return to Home
            </a>
            <a
              href="/projects"
              className="text-sm tracking-wide text-black border-b border-black pb-1 hover:opacity-60 transition"
            >
              View Projects
            </a>
          </div>
        </motion.div>

        {/* Subtle animated line */}
        <motion.div
          className="absolute bottom-20 left-1/2 -translate-x-1/2 h-px w-40 bg-gray-300"
          animate={{ width: [40, 160, 40], opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
        />
      </section>

      <Footer />
    </div>
  );
};

export default Soon;
